import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { Service as ServiceStorage } from '@services/storage.service';
import { Service as TicketSupportService } from '@services/ticket_support.service';
import { Service as TicketSupportCloseService } from '@services/ticket_support_close.service';

@Component({
    standalone: true,
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.html',
    styleUrls: ['./auth-layout.scss'],
    imports: [CommonModule, RouterOutlet, TranslateModule],
})

export class AuthLayout implements OnInit, OnDestroy {
    private Subscription!: Subscription;

    constructor(
        private TicketSupportCloseService: TicketSupportCloseService,
        private TicketSupportService: TicketSupportService,
        private ServiceStorage: ServiceStorage,
    ) { }

    ngOnInit() {
        document.body.classList.remove('g-sidenav-show', 'g-sidenav-pinned', 'bg-gray-100');
        document.body.classList.add('bg-white');

        this.TicketSupportCloseService.autoClose$.subscribe(async (data: any) => {
            await this.TicketSupportService.updateStatus({ status: 'close' }, data.item_id );
            await this.ServiceStorage.remove('ticket_support_timer');
        });

        this.TicketSupportCloseService.restoreTimer();
    }

    ngOnDestroy() {
        document.body.classList.remove('bg-white');
        this.Subscription?.unsubscribe();
    }
}